import React, { useEffect, useRef } from 'react';

const IconLoader = () => {
  // Ref for the <g> wrapping the “A” path
  const aGroupRef = useRef(null);

  useEffect(() => {
    const gEl = aGroupRef.current;
    if (!gEl) return;

    // Find the path inside that group
    const pathEl = gEl.querySelector('path');
    if (!pathEl) return;

    // Compute its bounding box
    const bbox = pathEl.getBBox(); // { x, y, width, height }

    const scale = 5.5;
    // local center of the letter
    const cx = bbox.x + bbox.width / 2;
    const cy = bbox.y + bbox.height / 2;

    // translate so that (cx, cy) * scale ends up at (50,50)
    const tx = 50 - cx * scale;
    const ty = 50 - cy * scale;

    gEl.setAttribute('transform', `translate(${tx},${ty}) scale(${scale})`);
  }, []);

  return (
    <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <title>Loader Logo</title>
      <g>
        {/* “A” group: transform will be set dynamically */}
        <g ref={aGroupRef}>
          <path
            d="M18.1 6c-1.1 2.913-1.9 4.913-2.4 6c-1.879 4.088-3.713 6-6 6c-2.4 0-4.8-2.4-4.8-6s2.4-6 4.8-6c2.267 0 4.135 1.986 6 6c.512 1.102 1.312 3.102 2.4 6"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconLoader;
